import request from './request'

export function getSpecial(query) {
    return request({
        url: '/huhuapi/special/show',
        method: 'post',
        data: query
    });
}

export function giftcardDetail(query) {
    return request({
        url: '/huhuapi/center/giftcardDetail',
        method: 'post',
        data: query
    });
}

export function WapconfirmPay(query) {
    return request({
        url: '/huhuapi/order/WapconfirmPay',
        method: 'post',
        data: query
    });
}

export function albumIndex(query) {
    return request({
        url: '/huhuactivity/index/index618',
        method: 'post',
        data: query
    });
}